import React from 'react';
import BreadcrumbItem from "../../component/BreadcrumbItem/BreadcrumbItem";
import Page from "../../component/Page/Page";
import DashboardTemplatesForm from "../../component/DashboardTemplates/DashboardTemplatesForm";

class TemplatesDashboardFormPage extends React.Component {
  render() {
    const {match, history} = this.props;
    const breadcrumbs = [
      <BreadcrumbItem key={1} title="Cadastros"/>,
      <BreadcrumbItem key={2} title="Lista de Templates de Dashboard" to="/dashboard-templates"/>,
      <BreadcrumbItem key={3} title="Novo tipo de template de dashboard" active={true}/>];
    return (
        <Page title="Dados do Tipo de Produtos" breadcrumbs={breadcrumbs}>
          <DashboardTemplatesForm match={match} history={history}/>
        </Page>
    );
  }
}

export default TemplatesDashboardFormPage;



// WEBPACK FOOTER //
// ./src/pages/DashboardTemplates/DashboardTemplatesFormPage.js